import { z } from "@/zod";

export const twoPlacesDecimalString = z
  .string()
  .pipe(z.coerce.number().min(0.1).multipleOf(0.01))
  .transform((val) => val.toString());

export const twoPlacesDecimalStringAllowZero = z
  .string()
  .pipe(z.coerce.number().min(0).multipleOf(0.01))
  .transform((val) => val.toString());
